import { useDiagramContext } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/contexts/DiagramContext';

interface DiagramBarProps {
  x: number;
  y: number;
  width: number;
  win?: boolean;
}

export const DiagramBar = ({ x, y, width, win = false }: DiagramBarProps) => {
  const { colors } = useDiagramContext();

  return (
    <rect
      x={x}
      y={y}
      width={width}
      height={12}
      rx={Math.min(colors.radius, 3)}
      fill={win ? colors.barWin : colors.bar}
    />
  );
};
